var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"text-uppercase font-weight-bold",attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-icon',{attrs:{"color":_vm.status.color}},[_vm._v(_vm._s(_vm.status.icon))]),_vm._v(" "+_vm._s(_vm.status.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }